module.exports = __webpack_public_path__ + "img/thumbnail_GiantAnteater_j_albino.8f12df07.png";